import { render, staticRenderFns } from "./ShipmentItem.vue?vue&type=template&id=3827faea"
import script from "./ShipmentItem.vue?vue&type=script&lang=ts"
export * from "./ShipmentItem.vue?vue&type=script&lang=ts"
import style0 from "./ShipmentItem.vue?vue&type=style&index=0&id=3827faea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports